import React from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { styles } from './styles';
import { useCareerQuery } from '../../../app/queries/career.query';
import SwiperComponent from '../../../shared/SwiperComponent/SwiperComponent';
import Section from '../../../shared/Section/Section';
import CoachingBenefitsStep from '../../../shared/CoachingBenefitsStep/CoachingBenefitsStep';
import CoachingBenefitsCard from '../../../shared/Cards/CoachingBenefitsCard';

function CoachingBenefits({ title, list }) {
  const { careerImgs } = useCareerQuery();
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return !isSm ? (
    <Box sx={styles.root} maxWidth="xl" id="advantages">
      {list.map((card, index) => {
        const extraPicture =
          index === 3 ? careerImgs[`career/you_will_get/roller-4`] : null;

        return (
          <CoachingBenefitsStep
            {...card}
            picture={
              careerImgs[`career/you_will_get/you_will_get-${index + 1}`]
            }
            index={index + 1}
            key={card.description}
            extraPicture={extraPicture}
          />
        );
      })}
    </Box>
  ) : (
    <Section subtitle={title} customStyles={{ padding: 2 }} anchor="advantages">
      <SwiperComponent
        slidesPerView={1.1}
        spaceBetween={34}
        breakpoints={{
          400: {
            slidesPerView: 1.2,
            spaceBetween: 28,
          },
          480: {
            slidesPerView: 1.3,
            spaceBetween: 34,
          },
        }}
        centeredSlides={false}
        slides={list.map(
          (card, index) =>
            function () {
              const numericIndex = index + 1;
              return (
                <CoachingBenefitsCard
                  {...card}
                  index={numericIndex}
                  picture={
                    careerImgs[
                      `career/you_will_get/you_will_get-${
                        numericIndex === 4 ? '4-mobile' : numericIndex
                      }`
                    ]
                  }
                  key={card.description}
                />
              );
            },
        )}
      />
    </Section>
  );
}

export default CoachingBenefits;
